export function getStrapiURL(path = "") {
    return `${
        process.env.REACT_APP_STRAPI_BACKEND_URL ? process.env.REACT_APP_STRAPI_BACKEND_URL : "http://localhost:1337"
    }${path}`;
  }